import { isString } from 'lodash';
import { ALL_COLORS, Color } from 'components/colors';
import { initials } from 'utils/initials';

export const getRandomColor = (
  seed: number | string,
  palette?: Color[],
): Color => {
  const _palette = palette ?? ALL_COLORS;

  if (isString(seed)) {
    const initialsString = initials(seed);
    let colorIndex = 0;

    [...initialsString].forEach((char, index) => {
      colorIndex += initialsString.charCodeAt(index);
    });

    colorIndex -= 'A'.charCodeAt(0);

    return _palette[Math.ceil(colorIndex) % _palette.length];
  }

  return _palette[Math.ceil(seed) % _palette.length];
};
